// extracted by mini-css-extract-plugin
export var arrow = "Checkbox-module--arrow--a8799";
export var arrowNo = "Checkbox-module--arrow_no--e129c";
export var arrowYes = "Checkbox-module--arrow_yes--eba2e";
export var checkboxContainer = "Checkbox-module--checkboxContainer--57f8e";
export var checkmarkAnimation = "Checkbox-module--checkmark_animation--584b1";
export var disabled = "Checkbox-module--disabled--52f59";
export var flex = "Checkbox-module--flex--2f5c3";
export var flex1 = "Checkbox-module--flex_1--5ebd4";
export var flexCenter = "Checkbox-module--flex_center--13b61";
export var flexCenterCol = "Checkbox-module--flex_center_col--9b5cd";
export var flexCol = "Checkbox-module--flex_col--e589c";
export var flexFixCenterCol = "Checkbox-module--flex_fix_center_col--6440d";
export var flexFixedCenterCol = "Checkbox-module--flex_fixed_center_col--61ae0";
export var lineAnimation = "Checkbox-module--line_animation--437f6";
export var rotating = "Checkbox-module--rotating--2931f";